(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  window.setUis24ActiveCategoryNav = () => {
    const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
    const currentPathWithHash = `${currentPath}${window.location.hash || ''}`;

    document.querySelectorAll('[data-uis24-nav-path]').forEach((link) => {
      const targetUrl = new URL(link.getAttribute('data-uis24-nav-path') || '/', window.location.origin);
      const targetPath = targetUrl.pathname.replace(/\/$/, '') || '/';
      const targetPathWithHash = `${targetPath}${targetUrl.hash || ''}`;
      let isActive = currentPath === targetPath;

      if (targetUrl.hash) {
        isActive = currentPathWithHash === targetPathWithHash;
      }

      if (link.classList.contains('uis24-category-nav__link')) {
        link.classList.toggle('uis24-category-nav__link--active', isActive);
      }

      if (link.classList.contains('uis24-drawer-primary__link')) {
        link.classList.toggle('is-active', isActive);
      }

      if (isActive) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  document.addEventListener('DOMContentLoaded', window.setUis24ActiveCategoryNav);
  document.addEventListener('shopify:section:load', window.setUis24ActiveCategoryNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uis24-product-inquiry"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeInquiry = (root) => {
      if (!root || root.dataset.inquiryInitialized === 'true') return;
      root.dataset.inquiryInitialized = 'true';

      const params = new URLSearchParams(window.location.search);
      const handle = params.get('handle');
      const requestedVariantId = params.get('variant');
      const fallbackTitle = params.get('produkt') || 'Ausgewaehlter Artikel';
      const title = root.querySelector('[data-inquiry-title]');
      const image = root.querySelector('[data-inquiry-image]');
      const placeholder = root.querySelector('[data-inquiry-placeholder]');
      const price = root.querySelector('[data-inquiry-price]');
      const variantLabel = root.querySelector('[data-inquiry-variant]');
      const sku = root.querySelector('[data-inquiry-sku]');
      const skuRow = root.querySelector('[data-inquiry-sku-row]');
      const backLink = root.querySelector('[data-inquiry-back-link]');
      const productField = root.querySelector('[data-inquiry-field-product]');
      const variantField = root.querySelector('[data-inquiry-field-variant]');
      const skuField = root.querySelector('[data-inquiry-field-sku]');
      const urlField = root.querySelector('[data-inquiry-field-url]');

      const setProductData = (product, variant) => {
        const productTitle = product.title || fallbackTitle;
        const productUrl = `${window.location.origin}${root.dataset.rootUrl || '/'}products/${product.handle}`;
        title.textContent = productTitle;
        if (productField) productField.value = productTitle;
        if (urlField) urlField.value = productUrl;
        if (backLink) {
          backLink.href = productUrl;
          backLink.lastChild.textContent = ' Zurück zum Artikel';
        }

        const imageUrl = product.featured_image || (product.images && product.images[0]);
        if (imageUrl && image) {
          image.src = imageUrl;
          image.alt = productTitle;
          image.hidden = false;
          if (placeholder) placeholder.hidden = true;
        }

        if (variant) {
          const formattedPrice = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR'
          }).format((variant.price || 0) / 100);
          if (price) price.textContent = formattedPrice;
          if (variant.title && variant.title !== 'Default Title') {
            variantLabel.textContent = variant.title;
            variantLabel.hidden = false;
          }
          if (variantField) variantField.value = variant.title || '';
          if (variant.sku) {
            sku.textContent = variant.sku;
            skuRow.hidden = false;
            if (skuField) skuField.value = variant.sku;
          }
        }
      };

      title.textContent = fallbackTitle;
      if (productField) productField.value = fallbackTitle;
      if (!handle) return;

      const rootUrl = (root.dataset.rootUrl || '/').replace(/\/$/, '');
      fetch(`${rootUrl}/products/${encodeURIComponent(handle)}.js`, {
        headers: { Accept: 'application/json' }
      })
        .then((response) => {
          if (!response.ok) throw new Error('Produkt konnte nicht geladen werden.');
          return response.json();
        })
        .then((product) => {
          const variant = product.variants.find((item) => String(item.id) === requestedVariantId) || product.variants[0];
          setProductData(product, variant);
        })
        .catch(() => {
          if (placeholder) placeholder.hidden = true;
          if (price) price.textContent = 'Preis und Verfügbarkeit auf Anfrage';
        });
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-product-inquiry]').forEach(initializeInquiry);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
